import { DecodedValueMap, SetQuery } from 'use-query-params'

import { AgentVerificationList } from '@percent/admin-dashboard/api/types'
import { AgentVerificationTableQueryParams } from '@percent/admin-dashboard/common/queryParams/queryParams.types'

export enum AgentVerificationStateFilter {
  all,
  'percent_actionable',
  'additional_document_review_needed',
  'external_actionable',
  approved,
  rejected
}
export type AgentVerificationState = keyof typeof AgentVerificationStateFilter

export type AgentVerificationTableProps = {
  validations: AgentVerificationList[] | null
  totalResults: number
  nextPage: (() => void) | null
  previousPage: (() => void) | null
  isLoading: boolean
  errorMessage: string | null
  queryParams: DecodedValueMap<AgentVerificationTableQueryParams>
  setQueryParams: SetQuery<AgentVerificationTableQueryParams>
}
